import { useAppSelector } from 'flex/utils';
import { useContext, useEffect } from 'react';
import * as Actions from 'flex/Actions';
import { ListContext } from '.';

// 役割一覧取得結果を ListContext に反映する effect component
export const RoleEffectComponent: React.FC = () => {
    const [, setList] = useContext(ListContext);
    const roleSearchConnection = useAppSelector(
        (state) => state.roleSearchConnection,
    );

    useEffect(() => {
        if (roleSearchConnection.meta.status === Actions.statusEnum.SUCCESS) {
            if (!roleSearchConnection.payload.result) return;
            setList((prev) => ({
                ...prev,
                roleList: roleSearchConnection?.payload?.result?.items ?? [],
                roleListItemCount:
                    roleSearchConnection?.payload?.result?.item_count ?? 0,
            }));
        }
    }, [roleSearchConnection]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
